<mat-card [class.selected]="tier?.selected">
  <mat-card-title class="text-truncate">
    <h2>Our most popular offer </h2>
  </mat-card-title>
  <mat-card-content *ngIf="tier">

    <div class="basic-info">

      <div class="tier-info">
        <span class="quantity">{{ tier?.quantity }} </span>
        <span class="copies">{{ 'book_price_offer.copies' | translate }}</span>
      </div>

      <div class="tier-info-small" *ngIf="tier.quantity">
        <span
          *ngIf="bookLaunchOffer?.product?.totalCurrencyPrice(currencyObserver.currentCurrency, tier.quantity || 1) !== tier?.currencyDiscountedAuthorPrice(currencyObserver.currentCurrency)">
          Pay
          <span class="old-price">{{ bookLaunchOffer?.product?.totalCurrencyPrice(currencyObserver.currentCurrency, tier.quantity || 1) | currency:currencyObserver.currentCurrency }}</span>
          <span class="new-price">{{ tier?.currencyDiscountedAuthorPrice(currencyObserver.currentCurrency) | currency:currencyObserver.currentCurrency }}</span>
          only
        </span>
      </div>

      <button mat-raised-button color="primary" (click)="addToCart()" *ngIf="tier" [disabled]="disabled">
        <mat-icon>add_shopping_cart</mat-icon>&nbsp;&nbsp;{{ 'cart.add' | translate }}
      </button>

    </div>

    <app-book-launch-offer-item-details [bookLaunchOffer]="bookLaunchOffer" [tier]="tier"
                                        [renderCartItem]="false"></app-book-launch-offer-item-details>

  </mat-card-content>
</mat-card>
